import { useMemo } from "react";
import { ConfigProvider } from "antd";
import { TextField } from "@mui/material";
import {
  Navigate,
  Route,
  Routes as Switch,
} from "react-router-dom";
import SSO from "../pages/SSO";
import { Login } from "../pages/Login";
import Cadastro from "../pages/Cadastro";
import PrivateRoute from "./PrivateRoutes";
import { Page } from "../constants/brokers";
import OnlyPublicRoute from "./OnlyPublicRoute";
import { MinhaConta } from "../pages/MinhaConta";
import { MeuPlano } from "../pages/MeuPlano";
import PageNotFound from "../pages/PageNotFound";
import { Regulation } from "../pages/Regulation";
import { Pages } from "../constants/brokers/pages";
import PageWrapper from "../components/PageWrapper";
import { Calculadoras } from "../pages/Calculadoras";
import { useBroker } from "../contexts/BrokerContext";
import { PublicWrapper } from "../components/PublicWrapper";
import { ForgotPassword } from "../pages/ForgotPassword";
import { ChangePassword } from "../pages/ChangePassword";
import { useAuth } from "../contexts/AuthContext";
import { Carteira } from "../pages/Carteira";

function Routes() {
  const { user } = useAuth();
  const { currentBroker } = useBroker();

  // const defaultPrivateRoute = useMemo(
  //   () =>
  //     integration.providerExists
  //       ? currentBroker.defaultProviderExistsPath ||
  //         `${currentBroker.path}/darf`
  //       : currentBroker.defaultPath || `${currentBroker.path}/integration`,
  //   [currentBroker, integration.providerExists]
  // );

  ConfigProvider.config({
    theme: {
      primaryColor: currentBroker?.colors.primary || "#1634ff",
      infoColor: currentBroker?.colors.secondary || "#000058",
      successColor: "#05aa99",
    },
  });

  const brokerRoutes = useMemo(
    () =>
      currentBroker.pages
        .reduce(
          (acc, cur) => [...acc, cur, ...(cur.subPages ?? [])],
          [] as Page[]
        )
        .filter((page) => !!page.component)
        .map((page) => {
          const Element = Pages[page.component!];
          return (
            <Route
              key={page.path}
              path={page.path}
              element={<Element item={page} />}
            />
          );
        }),
    [currentBroker]
  );

  return (
    <>
      <TextField
        variant="standard"
        style={{ display: "none", position: "fixed", top: 0, right: 0 }}
      />
      <Switch>
        <Route
          path="p"
          element={
            <PublicWrapper>
              <OnlyPublicRoute />
            </PublicWrapper>
          }
        >
          <Route path="login" element={<Login />} />
          <Route path="cadastrar" element={<Cadastro />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="change-password/:token" element={<ChangePassword />} />
          <Route path="" element={<Navigate to="cadastrar" />} />
          <Route path="*" element={<Navigate to="cadastrar" />} />
        </Route>
        {currentBroker.useSSO && (
          <Route path="p/sso/:token" element={<SSO />} />
        )}

        <Route
          path="/"
          element={
            <PageWrapper sideBar={true} header={true} overflow={true}>
              <PrivateRoute />
            </PageWrapper>
          }
        >
          {brokerRoutes}
          {currentBroker.useCarteira &&
            (currentBroker.hideCalculadoras ||
              user?.user?.visibleCalcs?.includes("carteira")) && (
              <Route path="/carteira" element={<Carteira />} />
            )}
          <Route path="/conta" element={<MinhaConta />} />
          <Route path="/regulacao" element={<Regulation />} />
          <Route path="/plano" element={<MeuPlano />} />
          <Route path="" element={<Navigate to={currentBroker?.defaultPath || 'mynt/crypto-darf'} />} />
          <Route path="*" element={<Navigate to={currentBroker?.defaultPath || 'mynt/crypto-darf'} />} />
        </Route>

        <Route
          path="/"
          element={
            <PublicWrapper>
              <PrivateRoute />
            </PublicWrapper>
          }
        >
          <Route path="calculadoras" element={<Calculadoras />} />
        </Route>

        <Route path="" element={<PageNotFound />} />
        <Route path="*" element={<PageNotFound />} />
      </Switch>
    </>
  );
}

export default Routes;
